module.exports = __webpack_public_path__ + "static/purposely.0e6efa97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/purposely.jpg
// module id = 126
// module chunks = 35783957827783 275188716799837